import React, { useState } from 'react';
import Calendar from 'react-calendar';
import { Translate } from '../../language';
import { useHistory } from "react-router-dom";
import LoginGoogle from '../../components/Login/LoginGoogle';
import Input from '../../utils/components/Input/Input'
import LoginFacebook from '../../components/Login/LoginFacebook';
import ModalTermsAndConditions from '../ModalTermsAndConditions/ModalTermsAndConditions';
import Button from '../../utils/components/Button/Button'
import Navbar from '../Navbar/Navbar/Navbar';
import useTimer from '../../utils/hooks/useTimer'
import BackGroundLogin from '../../assets/img/background.png';
import { LogoBorder } from '../../assets/icons';
import './ViewLogin.css';
import useModal from '../../utils/hooks/useModal';


const ViewLogin = ({
    islogin,
    isAdmin,
    isAcceptTermsView,
    isAcceptTerms,
    setIsAcceptTerms,
    type,
    error,
    errorPassword,
    isRecoverPassword,
    textRecoverPasword,
    img,
    textWelcome,
    inputValue,
    onChangeInput,
    onFocusInput,
    themeButton,
    nameInput,
    inputPlaceholder,
    textButton,
    actionButton,
    textDown,
    TextlinkDown,
    linkToDown,
    isMenuDown,
    isActiveButton,
    isExternalLogin,
    isConfirmationPassword,
    isLoginPassword,
    inputValuePassword,
    nameInputPassword,
    isRecoverPasswordCode,
    inputPlaceholderPassword,
    isResendCodeVerification,
    actionResendCode,
    model,
    isEnabled,
    setIsEnabled,
    gender,
    birthDate,
    setBirthDate,
    referralCode,

    referalcode,
    setReferalode,
    code,
    isCodeReferal,
    checkCode = () => { },
    setiIsCodeReferal = () => { },
    cleanCodeReferal = () => { },
    isLoading }) => {

    let history = useHistory();
    const [isShowModalTerms, setIsShowModalTerms] = useState(false)
    const [refCalendarExpe, isVisibleCalendarExpe, setIsVisibleCalendarExpe] = useModal(false)


    const [timeValidCode, setTimeValidCode] = useTimer(setIsEnabled, 5, 0)
    const [timeResendCode, setTimeResendCode] = useTimer(setIsEnabled, 0, 30)

    const selectTerms = (e) => {
        e.stopPropagation()
        setIsShowModalTerms(!isShowModalTerms)
    }
    return (
        <div className={'container-login'}>
            <Navbar islogin={islogin} />
            <img className={`background-login ${islogin ? 'login' : ''}`} src={BackGroundLogin} alt="imagen de login"></img>
            {isExternalLogin && <div className="title-register">{isShowModalTerms ? Translate('titleModalTerms', 'es') : Translate('register', 'es')}</div>}
            <form className={`form-login ${islogin ? '' : 'code'}`}>
                {/*  {!isLoginPassword && <div onClick={() => history.push('login')} className="back-to-login">{'<'}</div>} */}
                <div className={`row centerItems centerContent ${isLoginPassword ? '' : 'center-items-login'}`}>
                    <div className="content-icon-login">
                        <LogoBorder className="icon-border-login-view" />
                    </div>
                    {islogin && <Input
                        classNameContent={'input-email-login'}
                        type={type}
                        autoComplete="username"
                        name={nameInput}
                        value={inputValue}
                        onBlur={onChangeInput ? e => onChangeInput(e) : () => { }}
                        onChange={onChangeInput ? e => onChangeInput(e) : () => { }}
                        onFocus={onFocusInput ? e => onFocusInput(e) : () => { }}
                        placeholder={Translate(inputPlaceholder, 'es')}
                        error={error}
                    />}
                    {isLoginPassword &&
                        <>
                            <Input
                                classNameContent={'input-email-login'}
                                type={'password'}
                                autoComplete="current-password"
                                name={nameInputPassword}
                                value={inputValuePassword}
                                onBlur={onChangeInput ? e => onChangeInput(e) : () => { }}
                                onChange={onChangeInput ? e => onChangeInput(e) : () => { }}
                                onFocus={onFocusInput ? e => onFocusInput(e) : () => { }}
                                placeholder={Translate(inputPlaceholderPassword, 'es')}
                                errorPassword={errorPassword}
                            />

                            <div onClick={() => history.push('RecoverPassword')} className="forgot-password">Olvidé mi contraseña</div>
                        </>
                    }
                    {isLoginPassword &&
                        <>
                            {isLoading ?
                                <Button
                                    onClick={(e) => { }}
                                    disabled={true}
                                    text={Translate('checking', 'es')}
                                    theme="white"
                                    classNameContent="button-login-login"
                                /> :
                                <Button
                                    onClick={(e) => { actionButton(e) }}
                                    disabled={isActiveButton ? false : true}
                                    text={Translate(textButton, 'es')}
                                    theme="white"
                                    classNameContent="button-login-login"
                                />
                            }
                        </>
                    }
                </div>
                <div className={`row centerItems centerContent ${isLoginPassword ? '' : 'center-items-login'}`}>

                    {isResendCodeVerification &&
                        <div className="text-put-verification-code-login">
                            {Translate('putVerificationCode', 'es')}
                        </div>
                    }
                    {!islogin && <><Input
                        classNameContent={'input-email-login-80'}
                        type={type}
                        name={nameInput}
                        value={inputValue}
                        onBlur={onChangeInput ? e => onChangeInput(e) : () => { }}
                        onChange={onChangeInput ? e => onChangeInput(e) : () => { }}
                        onFocus={onFocusInput ? e => onFocusInput(e) : () => { }}
                        placeholder={Translate(inputPlaceholder, 'es')}
                        error={error}
                        center={true}
                    />{
                            isAcceptTermsView &&
                            <>

                                <select
                                    name={"gender"}
                                    className='mt-4 background-white input-email-login-80 input-select-style text-center'
                                    value={gender}
                                    onChange={onChangeInput ? e => onChangeInput(e) : () => { }}
                                    onFocus={onFocusInput ? e => onFocusInput(e) : () => { }}
                                >
                                    <option value="">{Translate("gender", 'es')}</option>
                                    <option value="male">Masculino</option>
                                    <option value="female">Femenino</option>
                                    <option value="another">Prefiero no decirlo</option>
                                </select>
                                <Input
                                    placeholder={'Fecha de nacimiento'}
                                    classNameContent={'input-email-login-80 pointer'}
                                    classNameInput={'mt-4 pointer'}
                                    type={type}
                                    name={"birdDate"}
                                    value={birthDate}
                                    onBlur={onChangeInput ? e => onChangeInput(e) : () => { }}
                                    onChange={onChangeInput ? e => onChangeInput(e) : () => { }}
                                    onClick={() => setIsVisibleCalendarExpe(true)}
                                    error={error}
                                    center={true}
                                />


                                {isVisibleCalendarExpe &&
                                    <div ref={refCalendarExpe} >
                                        <div
                                            style={{
                                                display: isVisibleCalendarExpe ? 'block' : 'none'
                                            }}
                                            className="calendar-register"
                                        >
                                            <Calendar

                                                onChange={(dateTime) => {
                                                    setBirthDate(new Date(dateTime).toLocaleDateString())
                                                    setIsVisibleCalendarExpe(false)
                                                }}

                                            />
                                        </div>
                                    </div>
                                }

                                {
                                    !code.valid ? (
                                        <Input
                                            error={(isCodeReferal && (code.valid === false)) && "Código invalido"}
                                            classNameContent="input-class-register-code"
                                            name="referralCode"
                                            type="text"
                                            placeholder={Translate('referralCode', 'es')}
                                            value={referalcode}
                                            onChange={e => {
                                                cleanCodeReferal()
                                                if (e.target.value.length > 0) {
                                                    setiIsCodeReferal(true)
                                                } else {
                                                    setiIsCodeReferal(false)
                                                }

                                                setReferalode(e.target.value.trimStart())
                                            }
                                            }
                                            onBlur={e => onChangeInput(e)}
                                            onFocus={e => onFocusInput(e)}
                                            onMouseOut={e => setReferalode(e.target.value.trim())}
                                            onKeyUp={onChangeInput ? e => onChangeInput(e) : () => { }}
                                        />
                                    ) : (
                                        <div>
                                            {code.user.name} {code.user.lastname}
                                        </div>
                                    )
                                }
                                <Button
                                    onClick={() => {
                                        if (isCodeReferal) {
                                            checkCode(referalcode)

                                        }

                                    }}
                                    text='Verificar' />



                            </>
                        }
                    </>

                    }
                    {isConfirmationPassword ?
                        <Input
                            classNameContent={'input-email-login'}
                            type={type}
                            name={nameInputPassword}
                            value={inputValuePassword}
                            onBlur={onChangeInput ? e => onChangeInput(e) : () => { }}
                            onChange={onChangeInput ? e => onChangeInput(e) : () => { }}
                            onKeyUp={onChangeInput ? e => onChangeInput(e) : () => { }}
                            onFocus={onFocusInput ? e => onFocusInput(e) : () => { }}
                            placeholder={Translate(inputPlaceholderPassword, 'es')}
                            error={errorPassword}
                            center={true}
                        />
                        :
                        <div></div>
                    }
                    {isResendCodeVerification &&
                        <>
                            <div className="valid-time-code-login">
                                {Translate('validTimeCode', 'es')}
                            </div>
                            <div className="color-purple-dark text-fz-4 text-bold">{timeValidCode}</div>
                        </>
                    }
                    {isAcceptTermsView && <>
                        <div className="content-acept-terms-register">
                            <input
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!isAcceptTerms) {
                                        selectTerms(e)
                                    }
                                }} checked={isAcceptTerms} type="checkbox" id="check-register" />
                            <label htmlFor="check-register" className="acept-terms-register">
                                {Translate('messageAcceptTerms', 'es')}
                            </label>
                        </div>
                        <ModalTermsAndConditions isAcceptTerms={isAcceptTerms} displayModal={isShowModalTerms} isChecked={() => { setIsAcceptTerms(true) }} closeModal={selectTerms} />
                    </>}
                    {isLoginPassword ?
                        <>
                            {
                                !isAdmin && <>
                                    <div className="create-acount-text">
                                        {Translate('questionRegister', 'es')}</div>
                                    <Button
                                        onClick={(e) => {
                                            e.preventDefault()
                                            history.push(linkToDown)
                                        }}
                                        text="Registrate"
                                        width="60%"
                                        styles={{ marginTop: '3%' }}
                                    />
                                </>
                            }
                        </> :
                        isLoading ?
                            <Button
                                onClick={(e) => { }}
                                disabled={true}
                                text={Translate('checking', 'es')}
                                classNameContent={'button-code-login'}
                                theme={isResendCodeVerification ? '' : 'white'}
                            /> :
                            <Button
                                onClick={(e) => { actionButton(e) }}
                                disabled={isActiveButton ? false : true}
                                text={Translate(textButton, 'es')}
                                classNameContent={'button-code-login'}
                                theme={isResendCodeVerification ? '' : 'white'}
                            />
                    }
                    {isResendCodeVerification &&
                        <>
                            {isEnabled ?
                                <Button
                                    onClick={(e) => {
                                        actionResendCode(e)
                                        setTimeValidCode(5, 0)
                                        setTimeResendCode(0, 30)
                                    }}
                                    disabled={false}
                                    text={Translate('reSendCode', 'es')}
                                    classNameContent={'button-code-login button-mt-2'}
                                    theme={isResendCodeVerification ? 'white' : themeButton}
                                /> :
                                <Button
                                    onClick={(e) => { }}
                                    disabled={true}
                                    text={Translate('reSendCodeIn', 'es') + timeResendCode}
                                    classNameContent={'button-code-login button-mt-2'}
                                    theme={isResendCodeVerification ? 'white' : themeButton}
                                />}
                        </>
                    }
                    {(isMenuDown) ?
                        isResendCodeVerification ?
                            <></>
                            :

                            !isAdmin && <div className="row centerItems centerContent">
                                <div className="login-with-social-buttons">{Translate('loginWithAnotherWay', 'es')}</div>
                                <div className="content-social-buttons">
                                    <LoginFacebook model={model} domain='1' history={history}></LoginFacebook>
                                    <LoginGoogle model={model} domain='2' history={history}></LoginGoogle>
                                </div>
                                {/*   <div className='column mt-1 mb-1'>
                                    <div className={'text-down-login text-black'}>{Translate(textDown, 'es') !== '???' && Translate(textDown, 'es')}</div>
                                    <Link className='text-link-red text-red' to={linkToDown}>{Translate(TextlinkDown, 'es') !== '???' && Translate(TextlinkDown, 'es')}</Link>
                                </div> */}
                            </div>


                        :
                        <div></div>
                    }
                    {/*    {isRecoverPassword &&
                        <div className="color-purple-dark text-bold parent-width row centerItems">{Translate(textRecoverPasword, 'es')}</div>
                    } */}
                </div>
            </form>
        </div>
    )
}

export default ViewLogin